import type { RefinementListProvided } from 'react-instantsearch-core';
import { connectRefinementList } from 'react-instantsearch-dom';

import { FC, useMemo, useRef } from 'react';

import { Button, Form, InputGroup } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import difficultyLevels from '@website/dataObjects/difficultyLevels';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import { BsCaretDownFill } from 'react-icons/bs';

export const FilterByDifficultyLevelInner: FC<RefinementListProvided> = ({
  items,
  currentRefinement,
  refine,
}) => {
  const typeAheadRef = useRef(null);

  // takes the difficult levels available for search from algolia and converts
  // them to friendly labels
  const options = useMemo(() => {
    return items
      .sort((l1, l2) => {
        if (parseInt(l1.label) > parseInt(l2.label)) {
          return 1;
        }
        if (l1.label < l2.label) {
          return -1;
        }
        return 0;
      })
      .map(
        ({ label }) =>
          difficultyLevels.find(({ value }) => value === parseInt(label)).label,
      );
  }, [items]);

  // takes in a list of difficult level numbers and converts it to label form
  const currentRefinementList = useMemo(() => {
    return currentRefinement.map(
      (refinementValue) =>
        difficultyLevels.find(
          ({ value }) => value === parseInt(refinementValue),
        ).label,
    );
  }, [currentRefinement]);

  const searchResults = (labelArray: string[]) => {
    const levels = labelArray.map((level) =>
      difficultyLevels.find(({ label }) => label === level).value.toString(),
    );
    refine(levels);
  };

  return (
    <Form.Group controlId="difficultyLevel">
      <Form.Label>Difficulty</Form.Label>
      <InputGroup>
        <Typeahead
          id="difficultyLevel"
          selected={currentRefinementList}
          multiple
          placeholder="Select..."
          onChange={(selected) => searchResults(selected as any)}
          options={options}
          inputProps={
            {
              'data-testid': 'filterByDifficultLevel',
            } as unknown
          }
          ref={typeAheadRef}
          onBlur={() => (typeAheadRef.current as any).toggleMenu()}
        />
        <Button
          onClick={() => (typeAheadRef.current as any).toggleMenu()}
          variant="light"
          style={{
            background: 'none',
            border: '1px solid #ced4da',
          }}
        >
          <BsCaretDownFill />
        </Button>
      </InputGroup>
    </Form.Group>
  );
};

const FilterByDifficultyLevel = connectRefinementList(
  FilterByDifficultyLevelInner,
);

export default FilterByDifficultyLevel;
